import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'assa_abloy_de',
} as IModuleProps;
